import React, { useEffect, useState } from 'react'
import FilesView from '../../../../Components/Utils/FilesView';

function ViewEquipmentsClient({ item, data, open, onCancel }) {
       const displayItem = data;

       
  const [filePathList, setFilePathList] = useState([]);

    useEffect(() => {
      if (
        data?.equipmentImage !== null &&
        data?.equipmentImage !== "None" &&
        data?.equipmentImage !== "[]"
      ) {
        setFilePathList(data?.equipmentImage?.length>0 ? data?.equipmentImage : []);
      }
    }, [data]);
    return (
      <div className="w-full flex flex-col flex-wrap gap-5">
        <div className='my-2'>
          <p className='text-[13px] font-medium text-mainColor-400 py-1'>Equipment</p>
          <p className='text-xs text-mainColor-400'>{displayItem?.name || "-"}</p>
        </div>
        <div className='flex flex-wrap sm:flex-nowrap gap-10 w-full'>
           {/* <div className='my-2 w-[30%]'>
          <p className='text-[13px] font-medium text-mainColor-400 py-1'>Ref</p>
          <p className='text-xs text-mainColor-400'>{displayItem?.refNumber || "-"}</p>
        </div> */}
        <div className='my-2 w-[30%]'>
          <p className='text-[13px] font-medium text-mainColor-400 py-1'>Unit</p>
          <p className='text-xs text-mainColor-400'>{displayItem?.unit || "-"}</p>
        </div>
        <div className='my-2 w-[30%]'>
          <p className='text-[13px] font-medium text-mainColor-400 py-1'>Quantity</p>
          <p className='text-xs text-mainColor-400'>{displayItem?.quantity || "-"}</p>
        </div>
        {/* <div className='my-2 w-[30%]'>
          <p className='text-[13px] font-medium text-mainColor-400 py-1'>Brand</p>
          <p className='text-xs text-mainColor-400'>{displayItem?.brand || "-"}</p>
        </div>
        <div className='my-2 w-[30%]'>
          <p className='text-[13px] font-medium text-mainColor-400 py-1'>Model No</p>
          <p className='text-xs text-mainColor-400'>{displayItem?.model || "-"}</p>
        </div> */}
        </div>
        {data?.equipmentImage?.length > 0 && (<>
        <p className=" p-1 text-xs font-medium text-[#111537]">
                  Attachments
                </p>
                <div className="overflow-y-scroll h-28 rounded-lg p-2">
                  {/* <SmallHeading title={"PR Attachments"} /> */}

                  <div className="w-full flex gap-2 flex-wrap ">
                    {data?.equipmentImage &&
                      filePathList.map((imgs, idx) => {
                        console.log("img", imgs);
                        return (
                          <FilesView fileView={imgs} key={idx} />
                        );
                      })}
                  </div>
                </div>
                </>)}
      </div>
    );
  }
export default ViewEquipmentsClient